import { createCarouselAndChildrenNodes } from '../../utils/functions'

// eslint-disable-next-line
export default async (component, event, ui) => {
  // eslint-disable-next-line
  const carouselNode = createCarouselAndChildrenNodes(event, ui)
}